import { render } from "./LKFModal.vue?vue&type=template&id=42853d7a&ts=true"
import script from "./LKFModal.vue?vue&type=script&lang=ts"
export * from "./LKFModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__